import * as React from "react";

// HOC
import withAccountHOC from "./withAccountHOC";


// components
import Modal from "~/components/modal/Modal";

// actions
import {
    loginWithFacebook,
    loginWithGoogle,
    loginLocal
} from "~/actions/account";

interface IModalLogin {
    initRef: Function;
    dispatch: Function;
    isLoading: boolean;
    goWithAction: Function;
    error: string;
}

class ModalLogin extends React.Component<IModalLogin, any>{
    constructor(props: IModalLogin) {
        super(props);
    }

    emailRef = {
        value: ""
    };
    passwordRef = {
        value: ""
    };

    onClickLoginSocial = (type: string) => (): any => {
        switch (type) {
            case "facebook": return this.props.goWithAction(loginWithFacebook())
            case "google": return this.props.goWithAction(loginWithGoogle())
        }
    }

    onSubmit = async (e: any) => {
        e.preventDefault();
        this.props.goWithAction(loginLocal(
            {
                email: this.emailRef.value,
                password: this.passwordRef.value
            }
        ));
    }

    render() {
        return (
            <div className="ModalLogin">
                <Modal
                    bsSize="sm"
                    title="Login"
                    initRef={this.props.initRef}
                >
                    <div className="ModalLogin__show">
                        <div className="ModalLogin__show__content">
                            <div className="ModalLogin__show__content__header">
                                <div className="social">
                                    <div className="btn photo" onClick={this.onClickLoginSocial('facebook')}>
                                        <img src={`/assets/images/social/fb.png`} alt="" />
                                    </div>
                                    <div className="btn photo" onClick={this.onClickLoginSocial('google')}>
                                        <img src={`/assets/images/social/gg.png`} alt="" />
                                    </div>
                                    <div className="btn photo">
                                        <img src={`/assets/images/social/github.png`} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="ModalLogin__show__content__body">
                                <form onSubmit={this.onSubmit}>
                                    <div className="line"></div>
                                    <div className="form">
                                        <div className="email">
                                            <input type="text" placeholder='Email' ref={(ref: any) => this.emailRef = ref} />
                                        </div>
                                        <div className="password">
                                            <input type="password" placeholder='Password' ref={(ref: any) => this.passwordRef = ref} />
                                        </div>
                                        <div className="submit">
                                            <button type="submit">LOGIN</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />
                            <p className="text-danger">{this.props.error}</p>
                            {
                                this.props.isLoading &&
                                <div className="text-center">
                                    <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                                </div>
                            }
                            <br />
                            <br />
                            <div className="ModalLogin__show__content__footer">
                                <p>Forgot password? <a href="">click here</a></p>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withAccountHOC(ModalLogin)



// WEBPACK FOOTER //
// ./src/components/account/ModalLogin.tsx